module.exports = __webpack_public_path__ + "BAicon.png?6ef30f4f13b36f09af92e4ef23de6ba2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbs/BAicon.png
// module id = 33
// module chunks = 0